import AdyenModal from "../../adyen-modal";
import set from "lodash/set";
import get from "lodash/get";
import { Concrete } from "./layouts/concrete";
import { Lavish } from "./layouts/lavish";
import React from "react";
import { Minimalist } from "./layouts/minimalist";

export const navigateToSubscriptionSuccessPage = (props) => props?.navigateTo(`/subscription-success`);

export const getSupportedRecurringPaymentProvider = (plan) => {
  const paymentGateways = get(plan, ["supported_payment_providers"], []);
  const supportedGateways = [];
  const planMetadata = get(plan, ["metadata"], {});
  const currency = get(plan, "price_currency");

  paymentGateways.forEach((pg) => {
    // adyen and paytrail are auto linked and they won't appear in metadata
    if (pg === "paytrail" || pg === "adyen") {
      supportedGateways.push(pg);
      return;
    }
    const isLinkedPaymentGateway = get(planMetadata, [pg, "plan_id", currency], false);
    if (isLinkedPaymentGateway) supportedGateways.push(pg);
  });

  return supportedGateways[0]; // TODO: return whole array when we support multiple pgs
};

export const openPaymentScreen = (plan = {}, props) => {
  const paymentGateway = plan?.recurring
    ? getSupportedRecurringPaymentProvider(plan)
    : get(plan, ["supported_payment_providers", 0], "razorpay");

  if (!paymentGateway) {
    console.error("No payment gateway available to initiate payment");
    return null;
  }

  if (props?.captureShippingAddress) {
    const userMetaData = props?.userMetaData || {};
    const { line1, line2, city, country, pincode, state } = userMetaData?.address;
    const { dialCode, email } = userMetaData?.other;
    const formattedMetadata = {
      ...plan.metadata,
      phone_number: userMetaData?.["phone_number"],
      name: `${line1}`,
      address: `${line2}`,
      city: `${city}`,
      country: `${country}`,
      pin_code: `${pincode}`,
      state: `${state}`,
      dial_code: `${dialCode}`,
      email: `${email}`,
    };
    set(plan, ["metadata"], formattedMetadata);
  }

  switch (paymentGateway) {
    case "razorpay":
      return props.initRazorPayPayment(plan, "standard");
    case "paypal":
      const paypalOptions = {
        selectedPlan: plan,
        planType: "standard",
        returnUrl: `${document.location.origin}/paypal-payment-success`,
        cancelUrl: `${document.location.origin}/paypal-payment-failed`,
      };
      return props.initPaypalPayment(paypalOptions);
    case "omise":
      return props.initOmisePayment(plan, "standard");
    case "paytrail":
      const paytrailOptions = {
        selectedPlan: plan,
        planType: "standard",
        returnUrl: `${document.location.origin}/paytrail-success.html`,
        cancelUrl: `${document.location.origin}/paytrail-cancel.html`,
      };

      return props.initPaytrailPayment(paytrailOptions);
    case "adyen":
      const locale = get(
        props,
        ["config", "pagebuilder-config", "general", "accesstypeIntegration", "locale"],
        "en-US"
      );
      return props.initAdyenPayment(plan, "standard", AdyenModal, locale);
    case "stripe":
      return props.initStripePayment({
        argType: "options",
        selectedPlan: plan,
        planType: "standard",
        successUrl: `${document.location.origin}/subscription-success`,
        cancelUrl: `${document.location.origin}/subscription`,
      });
    default:
      console.error(`Payment gateway '${paymentGateway}' is not supported yet`);
  }
};

export const getSubscriptionLayout = (props) => {
  const layout = get(props, ["config", "pagebuilder-config", "subscription", "rows", 0, "layout"], "");

  switch (layout) {
    case "Concrete":
      return <Concrete {...props} />;
    case "Minimalist":
      return <Minimalist {...props} />;
    default:
      return <Lavish {...props} />;
  }
};
